import React, { ComponentPropsWithoutRef } from "react";
import * as styles from "./Paragraph.css";
import clsx from "clsx";

export interface ParagraphProps extends ComponentPropsWithoutRef<"p"> {
  size?: "Xs" | "Sm" | "Md" | "Lg" | "Xl" | "Xxl" | 'Xxxl'
  weight?: "normal" | "bold";
  className?: string;
  as?: "p" | "div";
}
export const Paragraph = ({
  size = "Md",
  weight = "bold",
  children,
  className,
  as = "p",
  ...props
}: ParagraphProps) => {
  const Component = as;
  return (
    <Component
      {...props}
      className={clsx(
        className,
        styles.paragraph({ size: size, weight: weight })
      )}
    >
      {children}
    </Component>
  );
};
